// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Earth Shield Sphere",
  id: "earth-shield-sphere",
  metadata: {
    aspect: SavedSpellAspect.Earth,
    imports: ["earth","shapes","wait"],
    icon: {
      "backgroundColor": 2629395,
      "layers": [
        {
          "iconKey": "earthSpike",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -3,
          "color": 13141588
        },
        {
          "iconKey": "delay",
          "position": {
            "x": 15,
            "y": -3
          },
          "scale": 0.59,
          "rotation": 4,
          "color": 15859711
        }
      ]
    },
  },
};

export default metadata;
